export default __webpack_public_path__ + "static/media/fashcard.1a2f6e0e.webp";